import { Component, EventEmitter, Output } from '@angular/core';
import { AppBaseComponent } from '../../app-base.component';

@Component({
    selector: 'app-back-button',
    templateUrl: './back-button.component.html',
    standalone: false
})
export class BackButtonComponent extends AppBaseComponent {
  @Output() triggered = new EventEmitter();

  onClick(): void {
    this.triggered.emit();
  }
}
